import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core";
import classNames from 'classnames';

const styles = theme => ({
    root: {
        position: 'relative',
    },
    background: {
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        overflow: 'hidden',
        perspective: '1000px',
        zIndex: -1,
    },
    backgroundImage: {
        position: 'absolute',
        top: -200, left: -200, right: -200, bottom: -200,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        transition: 'transform 250ms linear'
    },
    foregroundImage: {
        position: 'absolute',
        left: 0, right: 0, bottom: '-1vh',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& img': {
            height: 'auto', width: 'auto',
            maxHeight: '95vh',
            maxWidth: '50vw',
        }
    }
});

class DeepImage extends Component {

    constructor() {
        super();

        this.state = {
            perspective: 0,
            scaleX: 50,
            scaleY: 50,
            rotX: 0,
            rotY: 0,
        };

        this.onWindowResize = this.onWindowResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.onWindowResize);

        this.setPerspective();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
    }

    onWindowResize() {
        this.setPerspective();
    }

    setPerspective() {
        const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const {strengthX, strengthY} = this.props;

        const perspective = Math.max(w, h);
        const scaleX = Math.abs(strengthX/180 * perspective);
        const scaleY = Math.abs(strengthY/180 * perspective);
        this.setState({
            perspective,
            scaleX: scaleX + scaleY,
            scaleY: scaleY + scaleX
        });
    }

    onMouseMove = (e) => {
        if (!this.childRef || !this.bgRef || !this.containerRef) {
            return;
        }
        const {strengthX, strengthY} = this.props;
        const {clientX, clientY} = e;
        const {x, y} = this.getRelativePosition(clientX, clientY);

        const rotX = x * strengthX;
        const rotY = y * strengthY;

        this.setState({
            rotX, rotY
        });
    };

    getRelativePosition(x, y) {
        const {top, left, width, height} = this.boundingRect;
        x += -left - width/2;
        y += -top - height/2;

        return {
            x: Math.max(Math.min(x*2/width, 1), -1),
            y: Math.max(Math.min(y*2/height, 1), -1),
        }
    }

    setChildRef = (ref) => {
        if (!ref) {
            return null;
        }
        this.childRef = ref;
        this.boundingRect = this.childRef.getBoundingClientRect();
    };

    setBackgroundRef = (ref) => {
        if (!ref) {
            return null;
        }
        this.bgRef = ref;
    };

    setContainerRef = (ref) => {
        if (!ref) {
            return null;
        }
        this.containerRef = ref;
    };

    render() {
        const {classes, className, children, Overlay, backgroundImage, foregroundImage} = this.props;
        const {perspective, scaleX, scaleY, rotY, rotX} = this.state;

        const bgContainerStyle = {
            perspective
        };

        const bgStyle = {
            backgroundImage: 'url(' + backgroundImage + ')',
            top: -scaleY, bottom: -scaleY,
            left: -scaleX, right: -scaleX,
            transform: `rotateX(${rotY}deg) rotateY(${rotX}deg)`
        };

        return (
            <div className={classNames(classes.root)}>
                <div className={classes.background}
                     style={bgContainerStyle}
                     ref={this.setContainerRef}>
                    <div className={classes.backgroundImage}
                         ref={this.setBackgroundRef}
                         style={bgStyle} />
                    <div className={classes.foregroundImage}>
                        <img alt="" src={foregroundImage} />
                    </div>
                    {!!Overlay && <Overlay />}
                </div>
                <div className={classNames(classes.children, className)}
                     onMouseMove={this.onMouseMove}
                     ref={this.setChildRef}
                >
                    {children}
                </div>
            </div>
        );
    }
}

DeepImage.propTypes = {
    Overlay: PropTypes.func,
    backgroundImage: PropTypes.string.isRequired,
    foregroundImage: PropTypes.string.isRequired,
    strengthX: PropTypes.number,
    strengthY: PropTypes.number,
};

DeepImage.defaultProps = {
    Overlay: () => null,
    strengthX: -4,
    strengthY: 2,
};

export default withStyles(styles)(DeepImage);



// WEBPACK FOOTER //
// ./src/components/DeepImage/index.js